import { createSlice } from "@reduxjs/toolkit";

const initialState = { userId: "", userName: "", userRole: "", organizationId: "", redirectURL: "", logoutURL: "", isInternalUserMapped: 0, isInternalUser: 0, org_configurations: {} };

const userLoginSlice = createSlice({
  name: "userLogin",
  initialState,
  reducers: {
    setUserLogin: (state, action) => {
      const { user_id, users_name, user_intellicast_permission, org_id, redirect_url, logout_url, internal_user_mapped, internal_user, org_properties, all_content_types, permitted_content_types, intellicast_flag, intellidash_flag, permitted_products, dashboard_sources, primary_product, portal_url, dashboard_url } = action.payload;

      return {
        ...state,
        userId: user_id, userName: users_name, userRole: user_intellicast_permission, organizationId: org_id, redirectURL: redirect_url,
        logoutURL: logout_url, isInternalUserMapped: internal_user_mapped, isInternalUser: internal_user, org_configurations: org_properties, all_content_types: all_content_types, permitted_content_types: permitted_content_types, intellidash_flag: intellidash_flag,
        intellicast_flag: intellicast_flag,
        permitted_products: permitted_products,
        primary_product: primary_product,
        dashboard_sources: dashboard_sources,
        portal_url: portal_url, dashboard_url: dashboard_url
      };
    },
    setOrgConfigData: (state, action) => {
      state.org_config_data = action.payload;
    }
  },
});



export const { setUserLogin, setOrgConfigData } = userLoginSlice.actions;

export default userLoginSlice.reducer;
